import React from 'react'
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa'
const Pagination = ({
  currentPage = 1,
  handlePageChange,
  handleNextPage,
  handlePreviousPage,
  pages,
  disableRightArrow,
  disableLeftArrow,
}) => {
  return (
    <div className="flex items-center mt-3 cursor-pointer text-over-primary-background justify-center rounded text-sm">
      <button
        disabled={disableLeftArrow}
        className={`size-7 flex rounded-tl rounded-bl justify-center items-center disabled:hover:text-over-primary-background hover:text-primary ${
          disableLeftArrow ? 'opacity-50' : ''
        }`}
        onClick={handlePreviousPage}
      >
        <FaArrowLeft />
      </button>
      {pages.map(page => {
        return (
          <button
            onClick={() => handlePageChange(page)}
            className={`${
              currentPage === page ? 'text-primary' : ''
            } size-7 flex items-center justify-center hover:text-primary font-bold`}
            key={`paggination-button-${page}`}
          >
            {page}
          </button>
        )
      })}
      <button
        disabled={disableRightArrow}
        className={`size-7 flex items-center justify-center rounded-tr rounded-br disabled:hover:text-over-primary-background hover:text-primary ${
          disableRightArrow ? 'opacity-50' : ''
        }`}
        onClick={handleNextPage}
      >
        <FaArrowRight />
      </button>
    </div>
  )
}

export default Pagination
